__turbopack_context__.v({
  "mainMarket": "main-market-module-sass-module__Lylceq__mainMarket",
  "marketColumn-2": "main-market-module-sass-module__Lylceq__marketColumn-2",
});
